import createReadonlyRecord from './createReadonlyRecord';

const emptyRecord = createReadonlyRecord<PropertyKey, never>();

export default emptyRecord;
